import styled from '@emotion/styled';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
} from '@mui/material';
import { OptimizedImage } from '@web/common/components/optimized-image';
import { productKindDetails, SelectableProductKinds } from '@web/store/store-product-options';
import { FC } from 'react';

const MobileProductKindButton = styled.div`
  ${props => props.theme.breakpoints.up('md')} {
    display: none;
  }
  background-color: white;
  box-shadow: 0px -2px 4px -1px rgba(0, 0, 0, 0.2), 0px -4px 5px 0px rgba(0, 0, 0, 0.14),
    0px -1px 10px 0px rgba(0, 0, 0, 0.12);
`;

interface MobileProductKindSelectorProps {
  openDrawer: () => void;
  currentKind?: SelectableProductKinds;
}

export const MobileProductKindSelector: FC<MobileProductKindSelectorProps> = ({
  currentKind,
  openDrawer,
}) => {
  const currentProductKind = currentKind
    ? productKindDetails[currentKind]
    : { label: 'Todas as categorias', icon: '/icons/all-categories.svg' };

  return (
    <MobileProductKindButton>
      <List disablePadding>
        <ListItem button onClick={openDrawer}>
          <ListItemAvatar>
            <OptimizedImage src={currentProductKind.icon} ext="svg" width="40" height="40" />
          </ListItemAvatar>
          <ListItemText primary="Categoria" secondary={currentProductKind.label} />
          <ListItemSecondaryAction onClick={openDrawer}>
            <IconButton>
              <ExpandLessIcon fontSize="large" color="inherit" />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    </MobileProductKindButton>
  );
};
